/*
 * Ryan O'Dowd
 * 2025-07-08
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import PricingColumn from './PricingColumn';
import React from 'react';
import Text from '@components/common/Text';
import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';
import utilities from '@utils/utilities';

const PricingMatrix = () => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <PricingColumn
        title='Wrinkly apps'
        cost='$0 - free for everyone'
        features={[
          'Free to use',
          (textStyles, tooltipStyles) => <Text style={textStyles}>Account syncing between <Tooltip title='iOS, Android, desktop, and web'><Text style={[textStyles, tooltipStyles]}>all platforms</Text></Tooltip></Text>,
          (textStyles, __tooltipStyles, linkStyles) => <Text style={textStyles}>Access to all <Text style={[textStyles, linkStyles]} isLink={true} href='/bibles'>supported Bible translations</Text></Text>,
          'Read, play games, and complete tests',
          'Discover reading plans, memory goals, and more',
        ]}
      />

      <PricingColumn
        title='Classroom LMS'
        cost={`${utilities.prettyCurrency(globals.centsPerSeatTierOne)}/user/year`}
        hasBuyButton={true}
        features={[
          'Access to separate teacher portal',
          'Manage classrooms',
          'Assign lessons',
          'Upload custom curriculum',
          'Track student progress',
          // @TODO: coming soon: 'Export reports for parents',
        ]}
      />

      <PricingColumn
        title='Fundraising'
        cost='Contact us for rates'
        hasInfoButton={true}
        features={[
          'Sponsors donate per verse memorized',
          'Track participant progress',
          'Manage donor pledges',
          'Wrinkly handles all payment information',
        ]}
      />
    </View>
  );
};

export default PricingMatrix;
